import { computed, inject, Injectable, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { PersonDetailed } from '../../models/person/person-detailed';
import { AuthService } from '../auth/auth.service';

@Injectable({ providedIn: 'root' })
export class SelectedPersonService {
  private readonly _selectedPerson = signal<PersonDetailed | null>(null);
  readonly selectedPerson = this._selectedPerson.asReadonly();
  readonly isViewingOther = computed(() => this.selectedPerson() !== null);
  readonly effectivePersonId = computed<number | null>(() => {
    const selected = this.selectedPerson();
    return selected ? selected.id : null;
  });
  readonly resolvedPersonId = computed<number | null>(
    () => this.effectivePersonId() ?? this.loggedInUser()?.id ?? null,
  );
  readonly viewingPersonName = computed(
    () => this.selectedPerson()?.displayName ?? null,
  );

  private readonly authService = inject(AuthService);
  private readonly loggedInUser = toSignal(this.authService.loggedInUserSubj);
  private readonly _viewingStartedAt = signal<Date | null>(null);
  readonly viewingStartedAt = this._viewingStartedAt.asReadonly();

  setSelection(person: PersonDetailed): void {
    this._viewingStartedAt.set(new Date());
    this._selectedPerson.set(person);
  }

  clearSelection(): void {
    this._selectedPerson.set(null);
    this._viewingStartedAt.set(null);
  }
}
